import { render } from "./ContentTree.vue?vue&type=template&id=b063336c&scoped=true"
import script from "./ContentTree.vue?vue&type=script&lang=js"
export * from "./ContentTree.vue?vue&type=script&lang=js"

import "./ContentTree.vue?vue&type=style&index=0&id=b063336c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b063336c"]])

export default __exports__